/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preference_Account_RequiredInputs */

const en_us2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not tell which account that setting belongs to. Sign in again.`)
};

const pt_br2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos identificar a conta dessa configuração. Entre novamente.`)
};

const es_419_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos identificar la cuenta de esa configuración. Vuelve a iniciar sesión.`)
};

const pt_pt2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos identificar a conta desta definição. Inicia sessão novamente.`)
};

const fr_fr2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de savoir à quel compte appartient ce réglage. Reconnecte-toi.`)
};

const de_de2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir konnten nicht erkennen, zu welchem Konto diese Einstellung gehört. Melde dich erneut an.`)
};

const it_it2_notification_preference_account_required = /** @type {(inputs: Notification_Preference_Account_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a capire a quale account appartiene questa impostazione. Accedi di nuovo.`)
};

/**
* | output |
* | --- |
* | "We could not tell which account that setting belongs to. Sign in again." |
*
* @param {Notification_Preference_Account_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const notification_preference_account_required = /** @type {((inputs?: Notification_Preference_Account_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preference_Account_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_notification_preference_account_required(inputs)
	if (locale === "es-419") return es_419_notification_preference_account_required(inputs)
	if (locale === "pt-PT") return pt_pt2_notification_preference_account_required(inputs)
	if (locale === "fr-FR") return fr_fr2_notification_preference_account_required(inputs)
	if (locale === "de-DE") return de_de2_notification_preference_account_required(inputs)
	if (locale === "it-IT") return it_it2_notification_preference_account_required(inputs)
	return en_us2_notification_preference_account_required(inputs)
});
export { notification_preference_account_required as "notification_preference.account_required" }